var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label":"文本内容："}},[_c('el-input',{attrs:{"type":"textarea","rows":2,"placeholder":"请输入文本内容"},model:{value:(_vm.tempText),callback:function ($$v) {_vm.tempText=$$v},expression:"tempText"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }